import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-select-studio-host-dialog',
  templateUrl: './select-studio-host-dialog.component.html',
  styleUrls: ['./select-studio-host-dialog.component.scss']
})
export class SelectStudioHostDialogComponent implements OnInit {
  hosting: boolean;

  hostingTypes = [
    {
      title: 'I want to host a competition',
      hosted: true,
      info: ''
    },
    {
      title: 'I want to list a competition',
      hosted: false,
      info: ''
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<SelectStudioHostDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {

  }

  selectedHosting(event) {
    this.hosting = event.value;
  }

  save() {
    this.dialogRef.close({hosting: this.hosting});
  }

  close(): void {
    this.dialogRef.close();
  }

}
